import React from 'react';
import {HomeCover, HomeOneImageInfo, HomeThreeImageInfo, BusinessArea, Overview, Partners, Portfolio, Map, Contact, Footer} from 'components/section';



const Home = () => {

  return (
    <div className = 'Home'>

        <HomeCover />
        <HomeOneImageInfo />
        <HomeThreeImageInfo />
        <BusinessArea />
        <Overview />
        <Partners />
        <Portfolio className="bgColor-lightGrey"/>
        <Map type = "withText" />
        <Contact className="bgColor-lightGrey"/>
        <Footer />

    </div>
  );
}

export default Home;